import PropTypes from "prop-types";
import Button from "../../../ui/Button";
import { CapsuleRiskScoresHeading, CRM_ECE_STUDY_URL } from "../constants";
import { sceneOrientations } from "../../../constants";

function CapsuleRiskMapHeader(props) {
    return (
        <div className="flex h-12 items-center justify-between bg-[#262626] pl-4">
            <div className="flex-col">
                <div className="text-lg font-medium">
                    {CapsuleRiskScoresHeading.TITLE}
                </div>
                <div className="text-sm">
                    {props.viewerOrientation !== sceneOrientations.AXIAL &&
                        CapsuleRiskScoresHeading.BTN_DESCRIPTION_NON_AXIAL}
                </div>
            </div>
            <div className="flex h-full items-center gap-1 bg-[#202020] px-4">
                <div className="w-20 text-sm">
                    {CapsuleRiskScoresHeading.BTN_DESCRIPTION}
                </div>
                <Button
                    id="crm-header-read"
                    className="text-sm"
                    text={CapsuleRiskScoresHeading.BTN_TEXT}
                    customWidth="w-16"
                    customHeight="h-8"
                    href={CRM_ECE_STUDY_URL}
                />
            </div>
        </div>
    );
}

CapsuleRiskMapHeader.propTypes = {
    viewerOrientation: PropTypes.string,
};

export default CapsuleRiskMapHeader;
